import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import {DataStoreService} from './data-store.service';
import {Element, mapElement} from './element';

declare var FormData;

export interface IElementForm {
  code: string;
  description: string;
  fields: string;
  folder_id: number|null;
  genre_id: number;
  id: number;
  name: string;
  project_id: number;
  subtitle: string;
  type_id: number;
}

// doesn't handle form file fields, minimum amount of key value pairs to save an element fields
// sending thtis json does not clear otther fields for the element such as fields, thtumbnail,
// video_preview, element_kits

export function mapElementToJson(element: Element) {

  return {
    genre_id: element.genre_id,
    name: element.name,
    type_id: element.type_id,
    folder_id: element.folder_id,
    subtitle: element.subtitle ? element.subtitle : 'blank',
    description: element.description ? element.description : '',
  }
}

@Injectable()
export class ElementService extends DataStoreService<Element> {

  constructor(private http: Http) {
    super();
  }

  save(element) {
    const kitId = element.kitId;
    element.fields.forEach((field, index) => {
      field.element_id = element.id;
      field.ord = index;
    });
    let tempElement = {
      id: element.id,
      name: element.name,
      subtitle: element.subtitle || "blank",
      description: element.description,
      folder_id: element.folder_id,
      genre_id: element.genre_id,
      type_id: element.type_id,
      fields: JSON.stringify(element.fields),
      code: element.code
    };

    let formData = new FormData();

    Object.keys(tempElement).map(key => {
      if (tempElement[key] !== null && key != 'folder_id') {
        formData.append(key, tempElement[key]);
      }
    });
    if (typeof element.thumbnail !== 'string' && element.thumbnail) {
      formData.append('thumbnail', element.thumbnail);
    }
    if (typeof element.video_preview !== 'string' && element.video_preview) {
      formData.append('video_preview', element.video_preview);
    }
    if (typeof element.video_preview !== 'string' && element.video_preview) {
      formData.append('video_preview', element.video_preview);
    }


    if (element.id) {
      formData.append('_method', 'PUT');
      return this.http
        .post(`${environment.apiUrl}/admin/elements/${element.id}`, formData)
        .map(this.extractData)
        .do(() => {

          // refresh the element for streaming data store
          // to guarantee consistency with front-end data
          // the response from post is not consistent with the api call i think
          this.getById(element.id).subscribe();
        })
        .catch(this.handleError);
    } else {
      formData.append('element_kits[]', element['element_kits[]']);

      return this.http
        .post(`${environment.apiUrl}/admin/elements`, formData)
        .map(this.extractData)
        .do((item) => {
          // refresh the element for streaming data store
          this.getById(item.id).subscribe();
        })
        .catch(this.handleError);
    }
  }

  moveElementToFolder(elementId: number, folderId: number): Observable<Element> {

    let element = this.find(+elementId);
    element.folder_id = folderId;

    return this.http.put(`${environment.apiUrl}/admin/elements/${element.id}`, mapElementToJson(element))
      .do(() => {
        this.update(element, {folder_id: folderId});
        return element;
      }).catch(this.handleError)
  }

  getById(id) {
    return this.http
      .get(`${environment.apiUrl}/elements/${id}`)
      .map(this.extractData)
      .map((getResponse: IGetElement) => {


        let element = mapElement(getResponse.element,
                                 getResponse.global_fields,
                                 getResponse.element.fields);


        let foundElement = this.find(element.id);
        if (foundElement) {
          this.update(foundElement, element);
          return foundElement;
        } else {
          this.insert(element.id, element);
          return element;
        }
      });
  }

  duplicateElement(kitId: number, elementId: number) {
    return this.http.post(`${environment.apiUrl}/admin/elements/duplicate`, {
      element_id: elementId,
      kit_id: kitId
    }).map(this.extractData)
      .do((item) => {
        let newElement = mapElement(Object.assign(item, {kit_id: +kitId}));
        this.insert(newElement.id, newElement);
      })
      .catch(this.handleError);
  }

  updateOrder(elements) {
    let order = [];

    elements.forEach((element, index) => {
      order.push({id: element.id, ord: index});
    });

    return this.http
      .post(
        `${environment.apiUrl}/elements/order/update`,
        {elements: JSON.stringify(order)}
      ).map(this.extractData);
  }

  delete(id) {
    return this.http
      .delete(`${environment.apiUrl}/elements/${id}`)
      .do(() => super.delete(+id))
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }

  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}


export interface IRawElementField {
  id: number;
  scope: string;
  kit_id?: any;
  element_id: number;
  label: string;
  engine_id: string;
  value: string;
  type: string;
  ord: number;
  created_at: string;
  updated_at: string;
  sub_label: string;
  options?: any;
  placeholder: string;
  required: number;
  limit: number;
  max_length?: any;
  hidden: number;
}

export interface IRawElementKitPivot {
  element_id: number;
  kit_id: number;
}

export interface IRawElementKit {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  video_preview: string;
  ord: number;
  created_at: string;
  updated_at: string;
  public: number;
  style_id: number;
  code: string;
  featured: number;
  banner: string;
  pivot: IRawElementKitPivot;
  fields: any[];
}

export interface IRawElement {
  id: number;
  name: string;
  description?: any;
  type_id: number;
  genre_id: number;
  video_preview: string;
  thumbnail?: any;
  created_at: string;
  updated_at: string;
  ord?: any;
  code: string;
  subtitle: string;
  folder_id?: any;
  archived: number;
  deleted_at?: any;
  type?: any;
  genre?: any;
  fields: IRawElementField[];
  kits: IRawElementKit[];
}

export interface IRawGlobalField {
  id: number;
  scope: string;
  kit_id?: any;
  element_id?: any;
  label: string;
  engine_id: string;
  value?: any;
  type: string;
  ord: number;
  created_at: string;
  updated_at: string;
  sub_label: string;
  options: string;
  placeholder: string;
  required: number;
  limit: number;
  max_length?: number;
  hidden: number;
}

export interface IGetElement {
  element: IRawElement;
  global_fields: IRawGlobalField[];
}


// WEBPACK FOOTER //
// ./src/app/services/element.service.ts